import { SurveyView } from "../Survey";
import BlueBlobIntro from '../../../assets/images/backgrounds/survey/intro/blue-blob.svg';
import GreenShapeIntro from '../../../assets/images/backgrounds/survey/intro/green-shape.svg';
import BlueCircleIntro from '../../../assets/images/backgrounds/survey/intro/blue-circle.png';
import GreenBlob0 from '../../../assets/images/backgrounds/survey/0/green-blob.svg';
import GreenShape0 from '../../../assets/images/backgrounds/survey/0/green-shape.png';
import GreenBlob1 from '../../../assets/images/backgrounds/survey/1/green-blob.svg';
import GreenShape1 from '../../../assets/images/backgrounds/survey/1/green-shape.png';
import GreenBlob2 from '../../../assets/images/backgrounds/survey/2/green-blob.svg';
import GreenShape2 from '../../../assets/images/backgrounds/survey/2/green-shape.png';
import GreenCircleLarge2 from '../../../assets/images/backgrounds/survey/2/green-circle-lg.png';
import PurpleBlob3 from '../../../assets/images/backgrounds/survey/3/purple-blob.svg';
import PurpleShape3 from '../../../assets/images/backgrounds/survey/3/purple-shape.png';
import BlueCircle3 from '../../../assets/images/backgrounds/survey/3/blue-circle.png';
import PurpleBlob4 from '../../../assets/images/backgrounds/survey/4/purple-blob.svg';
import PurpleBlob5 from '../../../assets/images/backgrounds/survey/5/purple-blob.svg';
import PurpleCircle6 from '../../../assets/images/backgrounds/survey/6/purple-circle.png';
import PurpleShape6 from '../../../assets/images/backgrounds/survey/6/purple-shape.png';
import BlueBlob6 from '../../../assets/images/backgrounds/survey/6/blue-blob.svg';
import BlueBlob7 from '../../../assets/images/backgrounds/survey/7/blue-blob.svg';
import BlueBlob8 from '../../../assets/images/backgrounds/survey/8/blue-blob.svg';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../../shared/Animations.scss';
import React, { Ref, useRef } from "react";


export function BackgroundLayerSurveyIntro({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={BlueBlobIntro} className="hidden md:flex absolute left-0 bottom-0 w-2/3" />
      <img alt="" src={GreenShapeIntro} className="hidden md:flex absolute right-0 top-14 w-1/4" />
      <img alt="" src={BlueCircleIntro} className="hidden md:flex absolute right-[3%] top-[250px] w-[5%]" />
    </div>
  );
}

export function BackgroundLayerSurvey0({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={GreenBlob0} className="hidden md:flex absolute right-0 bottom-0 w-2/3" />
      <img alt="" src={GreenShape0} className="hidden md:flex absolute left-0 bottom-0 w-1/6" />
    </div>
  );
}

export function BackgroundLayerSurvey1({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={GreenBlob1} className="hidden md:flex absolute left-0 bottom-0 w-1/2" />
      <img alt="" src={GreenShape1} className="hidden md:flex absolute right-0 top-80 w-1/6" />
    </div>
  );
}

export function BackgroundLayerSurvey2({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={GreenBlob2} className="hidden md:flex absolute right-0 bottom-0 w-7/12" />
      <img alt="" src={GreenShape2} className="hidden md:flex absolute left-0 bottom-0 w-1/5" />
      <img alt="" src={GreenCircleLarge2} className="hidden md:flex absolute right-[5%] top-[170px] w-[10%]" />
      <img alt="" src={GreenCircleLarge2} className="hidden md:flex absolute left-[35%] top-[725px] w-[5%]" />
    </div>
  );
}

export function BackgroundLayerSurvey3({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={PurpleBlob3} className="hidden md:flex absolute left-0 bottom-0 w-[45%]" />
      <img alt="" src={PurpleShape3} className="hidden md:flex absolute right-0 top-[180px] w-[15%]" />
      <img alt="" src={BlueCircle3} className="hidden md:flex absolute left-[480px] bottom-[150px]" />
    </div>
  );
}

export function BackgroundLayerSurvey4({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={PurpleBlob4} className="hidden md:flex absolute bottom-0 w-full" />
      <img alt="" src={BlueCircle3} className="hidden md:flex absolute -left-[50px] top-[180px]" />
      <img alt="" src={BlueCircle3} className="hidden md:flex absolute w-16 right-[50px] top-[200px]" />
    </div>
  );
}

export function BackgroundLayerSurvey5({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={PurpleBlob5} className="hidden md:flex absolute bottom-0 w-full" />
      <img alt="" src={BlueCircle3} className="hidden md:flex absolute w-16 left-[680px] bottom-[480px]" />
      <img alt="" src={BlueCircle3} className="hidden md:flex absolute right-[5%] top-[170px] w-[8%]" />
    </div>
  );
}

export function BackgroundLayerSurvey6({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={PurpleCircle6} className="hidden md:flex absolute right-[6%] bottom-[580px] w-[8%]" />
      <img alt="" src={BlueBlob6} className="hidden md:flex absolute right-0 bottom-0 w-1/3" />
      <img alt="" src={PurpleShape6} className="hidden md:flex absolute left-0 bottom-20 w-1/6" />
    </div>
  );
}

export function BackgroundLayerSurvey7({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={BlueBlob7} className="hidden md:flex absolute left-0 bottom-0 w-[65%]" />
      <img alt="" src={PurpleCircle6} className="hidden md:flex absolute right-[5%] top-[170px] w-[8%]" />
      <img alt="" src={PurpleCircle6} className="hidden md:flex absolute left-[675px] bottom-[610px] w-[4%]" />
    </div>
  );
}

export function BackgroundLayerSurvey8({ nodeRef }: { nodeRef: Ref<any> }) {
  return (
    <div ref={nodeRef} className="w-full h-full absolute">
      <img alt="" src={BlueBlob8} className="hidden md:flex absolute bottom-0 w-full" />
      <img alt="" src={PurpleCircle6} className="hidden md:flex absolute right-[5%] top-[170px] w-[8%]" />
      <img alt="" src={PurpleCircle6} className="hidden md:flex absolute left-[12%] bottom-[440px] w-[6%]" />
    </div>
  );
}

export function BackgroundLayer({
  surveyView,
  pageNumber
}: {
  surveyView: SurveyView,
  pageNumber: number
}) {
  const refs: {[key: string]: Ref<any> } = {
    'intro-0': useRef(null),
    'main-0': useRef(null),
    'main-1': useRef(null),
    'main-2': useRef(null),
    'main-3': useRef(null),
    'main-4': useRef(null),
    'main-5': useRef(null),
    'main-6': useRef(null),
    'main-7': useRef(null),
    'main-8': useRef(null)
  };

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={`${surveyView}-${pageNumber}`}
        in={true}
        nodeRef={refs[`${surveyView}-${pageNumber}`]}
        timeout={800}
        classNames="fade"
      >
        <React.Fragment>
          { surveyView === SurveyView.Intro && <BackgroundLayerSurveyIntro nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 0) && <BackgroundLayerSurvey0 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 1) && <BackgroundLayerSurvey1 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 2) && <BackgroundLayerSurvey2 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 3) && <BackgroundLayerSurvey3 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 4) && <BackgroundLayerSurvey4 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 5) && <BackgroundLayerSurvey5 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 6) && <BackgroundLayerSurvey6 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 7) && <BackgroundLayerSurvey7 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
          { (surveyView === SurveyView.Main && pageNumber === 8) && <BackgroundLayerSurvey8 nodeRef={refs[`${surveyView}-${pageNumber}`]} />}
        </React.Fragment>
      </CSSTransition>
    </TransitionGroup>
  );
}